import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import Flex from '../../atoms/Flex';
import { Link } from '@inertiajs/react';
import { color } from '../../templates/Ui';
// eslint-disable-next-line unused-imports/no-unused-vars
const StyledTabItem = styled(({ isActive, ...props }) => _jsx(Link, { ...props })) `
    position: relative;
    padding-bottom: 10px;
    margin-right: 20px;
    text-decoration: none;
    z-index: 1;
    height: 33px;

    &:after {
        transition: opacity 0ms ease-in-out;
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        height: 3px;
        border-radius: 2px;
        width: 100%;
        background-color: ${props => props.theme.secondary};
        opacity: ${props => (props.isActive ? '1' : '0')};
    }

    ${props => !props.isActive &&
    css `
            &:hover,
            &:focus {
                h4 {
                    color: ${props => props.theme.secondary};
                }

                svg {
                    fill: ${props => props.theme.secondary};
                }
            }
        `}
`;
const Icon = styled.div `
    display: inline-flex;
    margin-right: 8px;

    svg {
        transition: fill 0.2s ease-in-out;
        fill: ${props => props.isActive ? props.theme.primary.base : color.paragraph.base};
    }
`;
const Title = styled.h4 `
    transition: color 0.2s ease-in-out;
    font-size: 15px;
    line-height: 14px;
    font-weight: ${props => (props.isActive ? '700' : '400')};
    color: ${props => props.isActive ? props.theme.primary.base : color.paragraph.base};
    white-space: nowrap;
`;
const TabItem = ({ icon, title, href, isActive }) => {
    return (_jsx(StyledTabItem, { href: href, isActive: isActive, children: _jsxs(Flex, { alignItems: "center", children: [_jsx(Icon, { isActive: isActive, children: icon }), _jsx(Title, { isActive: isActive, children: title })] }) }));
};
export default TabItem;
